<template>
	<div>
		<transition name="expand">
			<amend-balance-modal v-if="showAmendBalanceModal" :tenant="editTenant" @close="closeAmendBalance" />
		</transition>
		<transition name="expand">
			<balance-history-modal v-if="showBalanceHistoryModal" :tenant="editTenant" />
		</transition>
		<transition name="expand">
			<barred-cli-modal v-if="showBlockedListModal" :tenant="editTenant" @save="saveBarredCliList" />
		</transition>
		<div class="stage">
			<div class="row margin-b20">
				<div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
					<div class="backBtn mobileMargin-b15">
						<router-link to="/tenants"
							><p
								class="textUppercase textGrey textXsml fontHeavy hover:text-[#555555] dark:hover:text-[#eeeeee]"
							>
								<span class="fa-light fa-arrow-left textGrey"></span> Take me back
							</p></router-link
						>
					</div>
				</div>
				<div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
					<ul class="stepBtnsRight">
						<li>
							<button
								:disabled="
									!editTenant.companyName ||
									!editTenant.reseller ||
									!editTenant.defaultNetworkNumber ||
									loading
								"
								class="jmiBtn btnLg green"
								@click="save()"
							>
								{{ editTenant.id ? 'Save' : 'Create' }}
							</button>
						</li>
						<li><button class="jmiBtn btnLg red" @click="routeTo('/tenants')">Close</button></li>
					</ul>
				</div>
			</div>
			<div class="row margin-b10">
				<div class="col-xs-12 col-sm-12 col-md-12 col-lg-8 col-lg-offset-2">
					<div class="row margin-b10">
						<div class="col-xs-12 col-sm-12 col-md-4 col-lg-4">
							<!-- <p class="textSml textGrey fontHeavy textUppercase">User</p> -->
						</div>
					</div>
					<div class="row margin-b20">
						<div class="w-full">
							<div class="card detailCard flex flex-col rounded-sm shadow-lg">
								<div class="mx-auto w-full">
									<div class="col-sm-12 textCenter flex flex-col items-center justify-center">
										<div class="navAvatar margin-b10">
											<img src="/assets/images/teleflow-logo-black.png" width="200" />
										</div>
									</div>
								</div>
								<div v-if="!loading">
									<div v-if="editTenant.id" class="margin-b10 text-center">
										<span>Current Balance: </span
										><strong>{{ $global.currencyGbp(editTenant.balanceGbp, 2) }}</strong>
									</div>
									<div
										class="my-4 flex w-full flex-col items-center justify-center gap-4 xs:flex-row"
									>
										<div v-if="editTenant.id" class="w-full md:w-auto">
											<button
												class="jmiBtn blue withIcon w-full md:w-auto"
												@click="showAmendBalance()"
											>
												<span class="fa-light fa-money-bill-transfer"></span>Adjust Balance
											</button>
										</div>
										<div v-if="editTenant.id" class="w-full md:w-auto">
											<button
												class="jmiBtn grey withIcon w-full md:w-auto"
												@click="showBalanceHistory()"
											>
												<span class="fa-light fa-clipboard-user"></span>Balance History
											</button>
										</div>
										<div v-if="editTenant.id" class="w-full md:w-auto">
											<button
												class="jmiBtn red withIcon w-full md:w-auto"
												@click="showBlockedList()"
											>
												<span class="fa-light fa-phone-slash"></span>Blocked CLI List
											</button>
										</div>
									</div>
									<div class="mb-6 mt-2 border-b border-dark dark:border-light">
										<h3 class="mb-2">Personal Information</h3>
									</div>
									<div class="mb-2 flex w-full flex-row flex-wrap md:mb-5">
										<div class="w-1/2 px-2">
											<div class="w-full">
												<div class="formGroup">
													<label class="textGrey">Company Name</label>
													<FormKit
														v-model="editTenant.companyName"
														type="text"
														class="form-control"
														required
														placeholder="Company Name"
														name="Company Name"
														:validation="'required'"
														validation-visibility="live"
													/>
												</div>
											</div>
										</div>
										<div class="w-1/2 px-2">
											<div class="w-full">
												<div class="formGroup">
													<label class="textGrey">Contact Name</label>
													<input
														v-model="editTenant.contactName"
														type="text"
														class="form-control"
														placeholder="Contact Name"
													/>
												</div>
											</div>
										</div>
									</div>
									<div class="mb-2 flex w-full flex-row flex-wrap md:mb-5">
										<div class="w-full px-2 md:w-1/2">
											<div class="w-full">
												<div class="formGroup">
													<label class="textGrey">Email</label>
													<input
														v-model="editTenant.email"
														type="email"
														class="form-control"
														placeholder="Email"
													/>
												</div>
											</div>
										</div>
										<div class="w-full px-2 md:w-1/2">
											<div class="w-full">
												<div class="formGroup">
													<label class="textGrey">Phone</label>
													<input
														v-model="editTenant.phone"
														type="text"
														class="form-control"
														placeholder="Phone"
													/>
												</div>
											</div>
										</div>
									</div>
									<div class="mb-6 mt-2 border-b border-dark dark:border-light">
										<h3 class="mb-2">Billing</h3>
									</div>
									<div class="mb-2 flex w-full flex-row flex-wrap md:mb-5">
										<div class="w-full px-2 md:w-1/2">
											<div class="formGroup withIcon">
												<label class="textGrey">Billing Type</label>
												<select v-model="editTenant.billingType">
													<option disabled :value="null">-- Select Billing Type --</option>
													<option value="PRE_PAID">Pre-paid</option>
													<option value="POST_PAID">Post-paid</option>
												</select>
												<span class="fa-light fa-chevron-down"></span>
											</div>
										</div>
										<div class="w-full px-2 md:w-1/2">
											<div class="formGroup">
												<label class="textGrey">Default Network Number</label>
												<FormKit
													v-model="editTenant.defaultNetworkNumber"
													type="text"
													class="form-control"
													placeholder="Default Network Number"
													name="Default Network Number"
													:validation="'required'"
													validation-visibility="live"
												/>
											</div>
										</div>
									</div>
									<div
										v-if="!editTenant.id && !$global.hasUserRole(userRoles, 'reseller')"
										class="mb-2 w-full px-2 md:mb-5"
									>
										<div class="col-md-12">
											<div class="formGroup withIcon">
												<label class="textGrey">Reseller</label>
												<select v-model="editTenant.reseller">
													<option :value="null">-- Select Reseller --</option>
													<option v-for="r in resellers" :key="r.id" :value="r">
														{{ r.companyName }}
													</option>
												</select>
												<span class="fa-light fa-chevron-down"></span>
											</div>
										</div>
									</div>
									<div
										v-if="editTenant.reseller"
										class="mb-2 flex w-full flex-col flex-wrap md:mb-5 md:flex-row"
									>
										<div class="w-full px-2 md:w-1/2">
											<div class="formGroup withIcon">
												<a
													class="group flex cursor-pointer gap-1"
													:href="
														editTenant.aLegTariffId || !editTenant.aLegTariffId === null
															? `/tariffs/${editTenant.aLegTariffId}`
															: 'javascript:void(0);'
													"
													:target="
														editTenant.aLegTariffId || !editTenant.aLegTariffId === null
															? `_blank`
															: ''
													"
												>
													<label class="textGrey cursor-pointer group-hover:underline"
														>A-Leg Tariff</label
													>
													<svg
														v-if="
															editTenant.aLegTariffId || !editTenant.aLegTariffId === null
														"
														class="mt-1"
														width="14"
														height="14"
														viewBox="0 0 24 24"
														fill="none"
														xmlns="http://www.w3.org/2000/svg"
													>
														<path
															d="M20 5H8V9H6V3H22V21H6V15H8V19H20V5Z"
															fill="currentColor"
														/>
														<path
															d="M13.0743 16.9498L11.6601 15.5356L14.1957 13H2V11H14.1956L11.6601 8.46451L13.0743 7.05029L18.024 12L13.0743 16.9498Z"
															fill="currentColor"
														/>
													</svg>
												</a>
												<select v-model="editTenant.aLegTariffId">
													<option :value="null">
														{{
															resellerTariffs?.length
																? '-- Select Tariff --'
																: '-- Please create a reseller tariff --'
														}}
													</option>
													<option
														v-for="tariff in resellerTariffs"
														:key="tariff.id"
														:value="tariff.id"
													>
														{{ tariff.name }}
													</option>
												</select>
												<span class="fa-light fa-chevron-down"></span>
											</div>
										</div>
										<div class="w-full px-2 md:w-1/2">
											<div class="formGroup withIcon">
												<a
													class="group flex cursor-pointer gap-1"
													:href="
														editTenant.bLegTariffId || !editTenant.bLegTariffId === null
															? `/tariffs/${editTenant.bLegTariffId}`
															: 'javascript:void(0);'
													"
													:target="
														editTenant.bLegTariffId || !editTenant.bLegTariffId === null
															? `_blank`
															: ''
													"
												>
													<label class="textGrey cursor-pointer group-hover:underline"
														>B-Leg Tariff</label
													>
													<svg
														v-if="
															editTenant.bLegTariffId || !editTenant.bLegTariffId === null
														"
														class="mt-1"
														width="14"
														height="14"
														viewBox="0 0 24 24"
														fill="none"
														xmlns="http://www.w3.org/2000/svg"
													>
														<path
															d="M20 5H8V9H6V3H22V21H6V15H8V19H20V5Z"
															fill="currentColor"
														/>
														<path
															d="M13.0743 16.9498L11.6601 15.5356L14.1957 13H2V11H14.1956L11.6601 8.46451L13.0743 7.05029L18.024 12L13.0743 16.9498Z"
															fill="currentColor"
														/>
													</svg>
												</a>
												<select v-model="editTenant.bLegTariffId">
													<option :value="null">
														{{
															resellerTariffs?.length
																? '-- Select Tariff --'
																: '-- Please create a reseller tariff --'
														}}
													</option>
													<option
														v-for="tariff in resellerTariffs"
														:key="tariff.id"
														:value="tariff.id"
													>
														{{ tariff.name }}
													</option>
												</select>
												<span class="fa-light fa-chevron-down"></span>
											</div>
										</div>
									</div>
									<div class="mb-2 flex w-full flex-row flex-wrap md:mb-5">
										<div class="w-full px-2 md:w-1/2">
											<div class="formGroup">
												<label class="textGrey">Balance Alert Amount</label>
												<input
													v-model="editTenant.alertAmount"
													type="number"
													class="form-control"
													placeholder="0"
												/>
											</div>
										</div>
										<div class="w-full px-2 md:w-1/2">
											<div class="formGroup">
												<label class="textGrey">Balance Alert Email</label>
												<input
													v-model="editTenant.alertEmail"
													type="email"
													class="form-control"
													placeholder="Alert Email"
												/>
											</div>
										</div>
									</div>
									<div class="mb-6 mt-2 border-b border-dark dark:border-light">
										<h3 class="mb-2">Fraud Control</h3>
									</div>
									<div class="mb-2 flex w-full flex-row flex-wrap md:mb-5">
										<div class="w-1/2 px-2">
											<div class="formGroup">
												<label class="textGrey">Concurrent Call Limit (0 = No Limit)</label>
												<input
													v-model="editTenant.concurrentCallLimit"
													type="number"
													class="form-control"
												/>
											</div>
										</div>
										<div class="w-1/2 px-2">
											<div class="formGroup">
												<label class="textGrey">Max Call Duration (mins)</label>
												<input
													v-model="editTenant.maxCallDurationMins"
													type="number"
													class="form-control"
												/>
											</div>
										</div>
									</div>
									<div class="mb-2 flex w-full flex-row flex-wrap md:mb-5">
										<div class="w-1/2 px-2">
											<div class="formGroup">
												<label class="textGrey">Max Daily Spend (GBP)</label>
												<input
													v-model="editTenant.limitDaily"
													type="number"
													class="form-control"
													step="0.01"
												/>
											</div>
										</div>
										<div class="w-1/2 px-2">
											<div class="formGroup">
												<label class="textGrey">Max Monthly Spend (GBP)</label>
												<input
													v-model="editTenant.limitMonthly"
													type="number"
													class="form-control"
													step="0.01"
												/>
											</div>
										</div>
									</div>
									<div class="margin-b20 flex px-2">
										<div class="col-md-12">
											<ul class="stepBtns">
												<li>
													<button
														:disabled="
															!editTenant.companyName ||
															!editTenant.reseller ||
															!editTenant.defaultNetworkNumber ||
															loading
														"
														class="jmiBtn btnLg green"
														@click="save()"
													>
														{{ editTenant.id ? 'Save' : 'Create' }}
													</button>
												</li>
												<li>
													<button class="jmiBtn btnLg red" @click="routeTo('/tenants')">
														Close
													</button>
												</li>
											</ul>
										</div>
									</div>
								</div>
								<div v-else>
									<div class="row margin-b20 center-xs center-md center-lg">
										<div class="loader"></div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import resellersApi from '../scripts/resellers/resellers.api'
import tenantsApi from '../scripts/tenants/tenants.api.js'
import tariffsApi from '../scripts/tariffs/tariffs.api'
import { router } from '../router'
import axios from 'axios'
import { computed } from 'vue'

export default {
	inject: ['user', 'userRoles'],
	provide() {
		return {
			editTenant: computed({
				get: () => this.editTenant,
				set: (val) => (this.editTenant = val)
			}),
			showAmendBalanceModal: computed({
				get: () => this.showAmendBalanceModal,
				set: (val) => (this.showAmendBalanceModal = val)
			}),
			showBalanceHistoryModal: computed({
				get: () => this.showBalanceHistoryModal,
				set: (val) => (this.showBalanceHistoryModal = val)
			}),
			showBlockedListModal: computed({
				get: () => this.showBlockedListModal,
				set: (val) => (this.showBlockedListModal = val)
			})
		}
	},

	data() {
		return {
			loading: true,
			showAmendBalanceModal: false,
			showBalanceHistoryModal: false,
			showBlockedListModal: false,
			editTenant: {
				companyName: '',
				contactName: '',
				email: '',
				phone: '',
				balanceGbp: 0.0,
				billingType: 'PRE_PAID',
				limitDaily: 0,
				limitMonthly: 0,
				maxCallDurationMins: 240,
				concurrentCallLimit: 0,
				defaultNetworkNumber: '',
				reseller: null,
				aLegTariffId: null,
				bLegTariffId: null,
				alertAmount: 0,
				alertEmail: ''
			},
			resellers: [],
			tariffs: [],
			ipAddresses: ['']
		}
	},

	computed: {
		resellerTariffs() {
			if (this.editTenant.reseller)
				return this.tariffs.filter(
					(t) => !t.tenant && t.reseller && t.reseller.id === this.editTenant.reseller.id
				)
			else return []
		}
	},

	async created() {
		try {
			const tariffResult = tariffsApi.getAll()
			const resellerResult = resellersApi.getAll()

			if (this.$route.params.id !== 'new') {
				const tenantResult = await tenantsApi.getById(this.$route.params.id)
				this.editTenant = tenantResult.data
			}

			this.tariffs = (await tariffResult).data.results
			this.resellers = (await resellerResult).data.results

			if (this.$route.params.id === 'new' && this.resellers?.length === 1)
				this.editTenant.reseller = this.resellers[0]

			this.loading = false
		} catch (e) {
			this.$swal({
				title: 'Error loading tenant',
				icon: 'error',
				confirmButtonText: 'Confirm',
				text: 'Unknown error occurred, please try again. If the issue persists, please raise a support ticket.'
			}).then(() => {
				router.push('/tenants')
			})
			console.error(e)
		}
	},

	methods: {
		saveBarredCliList(list) {
			tenantsApi.saveBarredCliList(this.editTenant.id, { barredCliList: list })
			this.editTenant.barredCliList = list
			this.closeBlockedList()
		},
		showAmendBalance() {
			this.showAmendBalanceModal = true
		},
		showBalanceHistory() {
			this.showBalanceHistoryModal = true
		},
		showBlockedList() {
			this.showBlockedListModal = true
		},
		closeBlockedList() {
			this.showBlockedListModal = false
		},
		closeAmendBalance() {
			this.showAmendBalanceModal = false
		},
		closeBalanceHistory() {
			this.showBalanceHistoryModal = false
		},
		routeTo(routeName) {
			router.push(routeName)
		},
		save() {
			if (!this.editTenant.id) {
				tenantsApi
					.create(this.editTenant)
					.then((res) => {
						window.location.href = '/tenants'
					})
					.catch(console.error)
			} else {
				tenantsApi
					.update(this.editTenant)
					.then((res) => {
						window.location.href = '/tenants'
					})
					.catch(console.error)
			}
		}
	}
}
</script>
